import { FinanceProgramForm } from '../schema';
import { mapCriteriaFormValuesToCreateInput } from './mapCriteriaFormValuesToCreateInput';
import { mapConfigurationFormValuesToCreateOrUpdate } from './mapConfigurationFormValuesToCreateOrUpdate';
import { CreateFinanceProgramInput } from '@trnsact/trnsact-shared-types/dist/generated';

export function mapFormValuesToCreateFinanceProgramInput(
  formValue: FinanceProgramForm,
  accountId: string
): CreateFinanceProgramInput {
  const {
    program: { first, second },
  } = formValue;

  const programAvailableForLenders = [...first.details.lenders, ...first.details.dealers].map(({ value }) => value);

  return {
    accountId,
    nameInternal: first.details.name,
    financeProgramModificationSettings: {
      markup: true,
    },
    lenderProfileIds: programAvailableForLenders,
    prescreenCriteriaIdToLink: first.criteria?.criteria?.value,
    scoreTiers: second.isTiersEnabled ? { tiers: second.tiers } : null,
    validDateEnd: second.isValidityDates ? second.endDate : null,
    validDateStart: second.isValidityDates ? second.startDate : null,
    prescreenCriteriaInput: mapCriteriaFormValuesToCreateInput(formValue, accountId),
    paymentOptionsConfiguration: mapConfigurationFormValuesToCreateOrUpdate(formValue),
    submissionSettings: {
      excludedDocuments: first.submissionSettings.excludedDocuments,
      autoSubmitUserProfileId: first.submissionSettings.autoSubmitUserProfileId,
    },
    insuranceCoverage: first.insuranceCoverage,
  };
}
